import { render, staticRenderFns } from "./TemplateSelectionSentPanel.vue?vue&type=template&id=48013e01&scoped=true"
import script from "./TemplateSelectionSentPanel.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionSentPanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionSentPanel.vue?vue&type=style&index=0&id=48013e01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48013e01",
  null
  
)

export default component.exports